import React from 'react'
import { replaceBadges } from 'lib/badges'
import AboutArtistConnector, { ConnectorProps as AboutArtistProps } from '../connectors/AboutArtist'

type Results = React.ReactElement<React.ComponentProps<any>, any> | null
export default AboutArtistConnector(
  (props: AboutArtistProps): Results => {
    const { badges } = props

    if (!badges || !badges.length) {
      return null
    }

    return (
      <div data-type='artist_badges'>
        <div data-type='title-section'>
          <h6 className='defaultTypographyH6'>Artist Recognition</h6>
        </div>
        <div data-type='badge-row'>
          {replaceBadges(badges).map(({ description, image, title }, key) => (
            <div data-type='badge-col' key={title}>
              <img className='lazyload' data-src={image} alt={title} width='30px' height='30px' />
              <p
                className='defaultTypographyMedium'
                data-type='badge-text'
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    )
  }
)
